export default "__VITE_ASSET__75173c2a__"